import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-24 md:pt-28 flex items-center justify-center min-h-[60vh]">
        <div className="text-center px-4">
          <div className="w-20 h-20 mx-auto rounded-full bg-warm-100 flex items-center justify-center mb-6">
            <i className="ri-error-warning-line text-3xl text-warm-400" />
          </div>
          <h1 className="font-heading text-3xl md:text-4xl font-bold text-warm-900 mb-4">
            {t('notFound.title')}
          </h1>
          <p className="text-sm md:text-base text-warm-500 mb-8 max-w-md mx-auto">
            {t('notFound.description')}
          </p>
          <a
            href="/"
            className="inline-flex items-center gap-2 px-6 py-3 bg-brand-600 text-white font-medium rounded-full hover:bg-brand-700 transition-colors"
          >
            {t('notFound.cta')}
          </a>
        </div>
      </main>
      <Footer />
    </div>
  );
}